import { Auth } from 'aws-amplify';
import {
  S3Client,
  GetObjectCommand,
  PutObjectCommand,
} from '@aws-sdk/client-s3';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';

export const getS3 = async () => {
  const credentials = await Auth.currentCredentials();
  const s3 = new S3Client({
    signatureVersion: 'v4',
    apiVersion: '2006-03-01',
    region: 'us-east-1',
    useAccelerateEndpoint: true,
    credentials,
  });
  return s3;
};

export const getUrl = async Key => {
  if (Key) {
    const s3 = await getS3();
    const cmd = new GetObjectCommand({
      Bucket: import.meta.env.VITE_FLOOR_PLAN_BUCKET,
      Key,
    });
    return getSignedUrl(s3, cmd, 6000);
  }
  return null;
};

export const uploadAsync = async (name, type, body) => {
  const s3 = await getS3();
  const cmd = new PutObjectCommand({
    Bucket: import.meta.env.VITE_FLOOR_PLAN_BUCKET,
    Key: name,
    Body: body,
    ContentType: type,
  });

  return s3.send(cmd);

  // return s3.upload({
  //     Bucket: import.meta.env.VITE_BUCKET,
  //     Key: filename ? folder + filename : folder + uuidv4() + extension,
  //     Body: file,
  // }).promise()
};
